import styled from 'styled-components';
import styledProps from 'styled-props';
import React from 'react';
import Text from './Text';
import Ratings from './Ratings';
import { Relative, Absolute, Flex, Box } from 'rebass';
import locationPin from './location-pin.svg';

import safeProps from '../safeProps';

const CardBox = styled.div`
  position: relative;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);
  padding: 0px 12px;
  display: inline-block;
  width: 100%;
  height: 100%;
`;

const CardImg = styled.div`
  background-size: cover;
  position: relative;
  background-image: ${props => `url("${props.image_src}")`};
  background-repeat: no-repeat;
  width: 100%;
  height:100%;
  margin: 0;
`;

const TextGrayBG = styled(Absolute)`
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 4px;
`;

const CardPrice = styled(TextGrayBG)`
  position: absolute;
  right: 0;
  top: 0;
`;

const Container = styled(Flex)`
  flex-grow: 1;
  padding-top: ${props => props.spacing};
  padding-bottom: ${props => props.spacing};
  margin-bottom: 0px;
`;
const ContainerShrink = styled(Flex)`
  flex-shrink: 1;
  padding-top: ${props => props.spacing};
  padding-bottom: ${props => props.spacing};
`;

const FlexFill = styled(Flex)`
  height: 100%;
`;

const A = styled.a`
  text-decoration: none;
  width: 100%;
`;

// const maxLargeDesc = 430;
// const maxSmallDesc = 80;

export default function(props) {
  props = safeProps(props);
  const comp = (
    <MainCardStyle {...props} />
  );

  return comp;
}

const MainCardStyle = props => {
  const {
    image_src,
    title,
    price,
    reviewCount,
    averageRating,
    location,
    description,
    ...rest
  } = props;
  const xsmall = props.xsmall;

  return (
    <CardBox {...rest}>
      <FlexFill flexDirection="column" flex={1}>
        <Container id="container-shrink">
          <A href={`/details/${props.id}`}>
            <CardImg {...rest} image_src={image_src}>
              <CardPrice>
                <Text xLarge white>
                  {props.price}/day
                </Text>
              </CardPrice>
            </CardImg>
          </A>
        </Container>
        <ContainerShrink
          id="text-container"
          flexDirection="column"
          justifyContent="space-between"
        >
          <ContainerShrink
            flexDirection="column"
            justifyContent="space-between"
            id="TopHolder"
          >
            <Flex flex={1} pb={1}>
              <A href={`/details/${props.id}`}>
                <Text
                  xLarge
                  primary
                  ml={3}
                >
                  {props.title}
                </Text>
              </A>
            </Flex>
            <Flex flex={1} mt={1}>
              <Flex
                flexDirection="row"
                justifyContent="space-between"
                width="100%"
              >
                <Box flex={1}>
                  <Text text grayDark ml={3}>
                    <img src={locationPin} /> {props.location}
                  </Text>
                </Box>
                {!xsmall && (
                  <Flex ml={3} mr={3}>
                    <Ratings medium rating={props.averageRating} />
                    <Text ml={2} subtext>
                      ({props.reviewCount})
                    </Text>
                  </Flex>
                )}
              </Flex>
            </Flex>
          </ContainerShrink>
        </ContainerShrink>
      </FlexFill>
    </CardBox>
  );
};



// WEBPACK FOOTER //
// ./src/components_new/common/Card.js